/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll(".js-navigation");
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 1300,
    menu: dropdown_menus[i],
  });
}

/**
 * Init publication modal(s)
 */
var publication_modals = document.querySelectorAll(".publications-modal");
for (var i = 0; i < publication_modals.length; i++) {
  component_publications_modal({
    modal: publication_modals[i],
  });
}

/**
 * Init services
 */
var services = document.querySelectorAll(".services");
for (var i = 0; i < services.length; i++) {
  component_services({
    services: services[i],
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu: document.querySelector(".js-mobile-menu"),
  site: document.querySelector(".js-page"),
  toggles: document.querySelectorAll(".js-menu-toggle"),
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener("lazybeforeunveil", function (e) {
    objectFitPolyfill();
    e.target.addEventListener("load", function () {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll(".lightbox").length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: "self",
      captionAttribute: "data-caption",
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/**
 * If there's a #hash in the URL, check if there's a matching anchor in a details block and make it open by default
 */

if (window.location.hash) {
  var hash = window.location.hash.substring(1);
  var details = document.getElementById(hash);

  if (details) {
    // close all other details blocks
    var details_blocks = document.querySelectorAll("details");
    for (var i = 0; i < details_blocks.length; i++) {
      details_blocks[i].open = false;
    }

    details.open = true;
  }
}
